import templateUrl from 'emun.vendor/documents/vendor-documents.htm'
import basicController from 'servicestack/basic.controller.properties'
import resolve from 'ioc/resolve'
import AutoQuery from 'servicestack/auto-query/auto-query.es6'
import ServiceBus from 'servicestack/service-bus'
import modals from 'webmodals/modals'
import "emun.vendor/documents/vendor-documents.scss";

class VendorDocumentsController {
    constructor($scope) {
        const $ctrl = this;
        basicController($ctrl);
		$ctrl.bus = new ServiceBus();
        $ctrl.realm = "VendorUploads";
    }
    $onInit(){
		const $ctrl = this;
		var url = `QueryMedia.json?Realm=${$ctrl.realm}`
		$ctrl.query = new AutoQuery({
			url: url,
			hideLeftNav: true,
			tagCriteria: {},
            pageSize: 1000,
			autoLoad: false,
		});

		$ctrl.bus.send("QueryVendors.json?Status=Active").then(function(args) {
			$ctrl.vendors = args.data.results;
            if ($ctrl.vendorId) {
                $ctrl.query.tagCriteria.Parent = $ctrl.vendorId;
                $ctrl.query.load();
            } else if ($ctrl.$session.isRetailer) {
                $ctrl.query.tagCriteria.Parent = $ctrl.$session.retailerId;
                $ctrl.query.load();
            }
		});

        $ctrl.bus.send("QueryVendorUploadFileTypes.json").then(function(args) {
            $ctrl.fileTypes = args.data.results;
            if ($ctrl.fileType) {
                $ctrl.selectedFileType = $ctrl.fileTypes.filter(f => f.fileType == $ctrl.fileType)[0];
                $ctrl.setFileType();
            }
        })

    }
    // setVendor() {
    //     const $ctrl = this;
    //     $ctrl.query.tagCriteria.Parent = $ctrl.vendorId;
    //     $ctrl.query.load();
    // }
    setFileType() {
        const $ctrl = this;
        $ctrl.query.tagCriteria.FileType = $ctrl.selectedFileType.fileType;
        $ctrl.query.load();
    }
    upload($files) {
        const $ctrl = this;
        if ($files && $files.length) {
            let req = {
                request: {
                    realm: $ctrl.realm,
                    description: $ctrl.fileType,
                    refId: $ctrl.vendorId,
                    tags: {
                        Visibility: "Public",
                        Parent: $ctrl.query.tagCriteria.Parent,
                        FileType: $ctrl.query.tagCriteria.FileType,
                        DestinationFilename: $ctrl.fileTypes.filter(f => f.fileType == $ctrl.query.tagCriteria.FileType)[0].destinationFilename,
                        DestinationFolder: $ctrl.fileTypes.filter(f => f.fileType == $ctrl.query.tagCriteria.FileType)[0].destinationFolder,
                    }
                },
                files: $files,
                urls: []
            };

            $ctrl.bus.upload("CreateMedia.json", req).then(function (response) {
                $ctrl.media = response.data.media[0];
                $ctrl.$broadcast("$documentUploaded");
                $ctrl.query.load(true);
                // $ctrl.$dismiss();
            });
        }
    };
	openDocument(doc) {
		let $ctrl = this;
		window.open(doc.url, doc.label);
	}
	deleteDocument(doc) {
		const $ctrl = this;
		return modals.confirm("Are you sure?", "Delete File").result.then(function () {
			$ctrl.bus.send('DeleteMedia.json', doc).then(function (response) {
				$ctrl.query.load();
			});
		});
	}

}

export default {
	bindings: {
        vendorId: '@',
        fileType: '@'
	},
    controller: VendorDocumentsController,
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl
    }
};